import { apiClient } from './apiClient';

export interface User {
  id: string;
  displayName: string;
  userPrincipalName: string;
  mail?: string;
  givenName?: string;
  surname?: string;
  jobTitle?: string;
  department?: string;
  officeLocation?: string;
  mobilePhone?: string;
  businessPhones?: string[];
  accountEnabled: boolean;
  createdDateTime?: string;
}

export interface CreateUserRequest {
  displayName: string;
  userPrincipalName: string;
  mailNickname: string;
  accountEnabled: boolean;
  passwordProfile: {
    password: string;
    forceChangePasswordNextSignIn: boolean;
  };
  givenName?: string;
  surname?: string;
  jobTitle?: string;
  department?: string;
}

export interface UpdateUserRequest {
  displayName?: string;
  givenName?: string;
  surname?: string;
  jobTitle?: string;
  department?: string;
  officeLocation?: string;
  mobilePhone?: string;
  accountEnabled?: boolean;
}

export interface UsersListResponse {
  success: boolean;
  data: {
    value: User[];
    '@odata.count'?: number;
    '@odata.nextLink'?: string;
  };
}

export interface UserResponse {
  success: boolean;
  data: User;
}

export const userService = {
  async getUsers(params?: {
    top?: number;
    skip?: number;
    filter?: string;
    search?: string;
    orderby?: string;
  }): Promise<UsersListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.top) queryParams.append('$top', params.top.toString());
    if (params?.skip) queryParams.append('$skip', params.skip.toString());
    if (params?.filter) queryParams.append('$filter', params.filter);
    if (params?.search) queryParams.append('$search', params.search);
    if (params?.orderby) queryParams.append('$orderby', params.orderby);

    return apiClient.get<UsersListResponse>(`/users?${queryParams.toString()}`);
  },

  async getUserById(userId: string): Promise<UserResponse> {
    return apiClient.get<UserResponse>(`/users/${userId}`);
  },

  async createUser(user: CreateUserRequest): Promise<UserResponse> {
    return apiClient.post<UserResponse>('/users', user);
  },

  async updateUser(userId: string, updates: UpdateUserRequest): Promise<UserResponse> {
    return apiClient.patch<UserResponse>(`/users/${userId}`, updates);
  },

  async deleteUser(userId: string): Promise<void> {
    return apiClient.delete(`/users/${userId}`);
  },

  async resetPassword(userId: string, newPassword: string, forceChange: boolean = true): Promise<void> {
    return apiClient.post(`/users/${userId}/reset-password`, {
      password: newPassword,
      forceChangePasswordNextSignIn: forceChange,
    });
  },

  async getUserLicenses(userId: string): Promise<any> {
    return apiClient.get(`/users/${userId}/licenses`);
  },
};
